import schema from "../../components/static/characteristics_schema.json";


export function GenerateCharacteristics(dataset) {
  let common = schema.Common;
  const specifics = schema.DatasetSpecific[dataset];
  const characteristics = {...specifics , ...common };
  return characteristics;
}

/**
 * Generate the schema based on the given dataset
 * @param {} dataset 
 * @returns 
 */
export function GenerateCharacteristicsForSelector(dataset) {
  let common = schema.Common;
  const specifics = schema.DatasetSpecific[dataset];
  const characteristics = {...specifics , ...common };

  return characteristics;
}